<template>
  <v-page page="My Account" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3 style="min-height: 46px;">
                  <v-flex align-center>
                    <div class="text-xs-left align-center" style="font-size: 20px; font-weight: 600;">Update Profile</div>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <v-form
                  ref="form"
                  v-model="valid">
                <v-layout row xs12>
                  <v-text-field xs8
                    v-model="username"
                    label="Username"
                    disabled
                  ></v-text-field>
                </v-layout>
                  
                <v-layout row xs12>
                  <v-text-field xs8
                      label="First Name" 
                      v-model="firstName"
                      required
                      :rules="requiredRules">
                  </v-text-field>
                </v-layout>

                <v-layout row xs12>
                  <v-text-field xs8
                      label="Last Name" 
                      v-model="lastName"
                      required
                      :rules="requiredRules">
                  </v-text-field>
                </v-layout>

                  
                <v-layout row>
                  <v-flex xs2 text-xs-left>
                    <span style="font-weight: bold;">Change Password</span>
                  </v-flex>
                  <v-flex xs4 text-xs-left>
                    <a @click="openChangePasswordDialog">Change</a>
                    
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs2 text-xs-left>
                    <span style="font-weight: bold;">Password Expiration</span>
                  </v-flex>
                  <v-flex xs4 text-xs-left>
                    {{ formatDate(passwordExpirationDate) }}
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs2 text-xs-left>
                    <span style="font-weight: bold;">Expires In</span>
                  </v-flex>
                  <v-flex xs4 text-xs-left>
                    {{ daysRemaining(passwordExpirationDate) }} day(s)
                  </v-flex>
                </v-layout>
                  
                </v-form>
                <changePassword ref="changePassword"></changePassword>
                <v-layout row>
                  <v-flex xs12 align-end>
                    <v-btn justify-end
                        :disabled="!valid"
                        color="success"
                        @click="validate">
                      Update
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
  import VPage from "../../layouts/Default.vue";
  import axios from "axios";
  import * as helper from "../../helpers/global.js";
  import moment from "moment";
  import Bus from "../../bus";
  import changePassword from "./ChangePassword.vue"

  export default {
    name: "MyAccount",

    components: {
      VPage,
      changePassword,
    },

    data: () => ({
      dialog: false,
      search: "",
      loading: true,

      valid: true,
      username: '',
      password: '',
      firstName: '',
      lastName: '',
      passwordExpirationDate: null,

      requiredRules:[v => !!v || 'This field is required'],
      
      breadcrumb: [
        {
        text: "My Account",
        disabled: false,
        href: "#/my-account"
        },
        {
        text: "Update Profile",
        disabled: true,
        href: "#/my-account"
        }
      ],
    }),

    created() {
      this.initialize()
    },

    methods: {
      initialize() {
        this.username = this.$store.state.auth.user
        axios.post('/api/User/GetUserDetails/',
          {
            "Username": this.username,
          }
        ).then((response) => {
          this.firstName = response.data.user.FirstName,
          this.lastName = response.data.user.LastName,
          this.passwordExpirationDate = response.data.user.ExpirationDate
        });
      },
      validate () {
        console.log("validate")
        if (this.$refs.form.validate()) {
          this.submitForm();
        }
      },
      submitForm(){
        console.log("submitForm")
        axios.post('/api/User/UpdateUserProfile/',
        {
          "Username": this.username,
          "FirstName": this.firstName,
          "LastName": this.lastName,
        });

        Bus.$emit("alert", {
              color: "success",
              message: "User Profile Updated!"
              });
      },
      formatDate(value){
        if(value)
          return moment(value).format('YYYY-MM-DD HH:mm:ss UTC Z')
        else
          return '';
      },
      daysRemaining(value){
        var a = moment(value);
        var b = moment();

        return a.diff(b,'days');
      },
      openChangePasswordDialog(){
        this.$refs.changePassword.open();
      },
    }
  };

</script>

<style scoped>
  table.v-table tbody td,
  table.v-table tbody th {
    height: 22px;
    font-size: 14px;
  }

  table.v-table tbody th {
    background-color: #4caf50;
  }

  table.v-table tbody tr:not(:last-child) {
    height: 22px;
    font-size: 14px;
  }
  .TierButton {
    border-color: #4caf50 !important;
    border-width: 1px !important;
    border-style: solid !important;
    color: #4caf50 !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }
  .TierButton:hover {
    background-color: #4caf50 !important;
    color: white !important;
  }
</style>
